export const COMMERCE_KIOSK_PATH = '/all';
export const PRODUCTS_MANAGE_PATH = '/products/manage';
export const PRODUCTS_CREATE_PATH = '/products/create';
export const CATEGORIES_PATH = '/categories';
export const CATEGORY_PROFILE_PATH = '/categories/profile/:id?';
export const NEW_CATEGORY_PATH = '/categories/profile';

export const editCategoryById = (categoryId: number): string =>
	`/categories/profile/${categoryId}`;
